/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Col, FormText, Row } from 'reactstrap';
import { Translate, ValidatedField, ValidatedForm, isNumber, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities as getMeals } from 'app/entities/meal/meal.reducer';
import { getEntities as getNutritionIPS } from 'app/entities/nutrition-ip/nutrition-ip.reducer';
import { createEntity, getEntity, reset, updateEntity } from './meal-nutrition.reducer';

export const MealNutritionUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const meals = useAppSelector(state => state.meal.entities);
  const nutritionIPS = useAppSelector(state => state.nutritionIP.entities);
  const mealNutritionEntity = useAppSelector(state => state.mealNutrition.entity);
  const loading = useAppSelector(state => state.mealNutrition.loading);
  const updating = useAppSelector(state => state.mealNutrition.updating);
  const updateSuccess = useAppSelector(state => state.mealNutrition.updateSuccess);

  const handleClose = () => {
    navigate(`/meal-nutrition${location.search}`);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }

    dispatch(getMeals({}));
    dispatch(getNutritionIPS({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    if (values.cursor !== undefined && typeof values.cursor !== 'number') {
      values.cursor = Number(values.cursor);
    }
    if (values.lastupdated !== undefined && typeof values.lastupdated !== 'number') {
      values.lastupdated = Number(values.lastupdated);
    }
    if (values.microSec !== undefined && typeof values.microSec !== 'number') {
      values.microSec = Number(values.microSec);
    }
    if (values.total !== undefined && typeof values.total !== 'number') {
      values.total = Number(values.total);
    }
    if (values.dailyTotal !== undefined && typeof values.dailyTotal !== 'number') {
      values.dailyTotal = Number(values.dailyTotal);
    }

    const entity = {
      ...mealNutritionEntity,
      ...values,
      meal: meals.find(it => it.id.toString() === values.meal?.toString()),
      nutrition: nutritionIPS.find(it => it.id.toString() === values.nutrition?.toString()),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          ...mealNutritionEntity,
          meal: mealNutritionEntity?.meal?.id,
          nutrition: mealNutritionEntity?.nutrition?.id,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="tinyMedicRestApp.mealNutrition.home.createOrEditLabel" data-cy="MealNutritionCreateUpdateHeading">
            <Translate contentKey="tinyMedicRestApp.mealNutrition.home.createOrEditLabel">Create or edit a MealNutrition</Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="meal-nutrition-id"
                  label={translate('tinyMedicRestApp.mealNutrition.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('tinyMedicRestApp.mealNutrition.active')}
                id="meal-nutrition-active"
                name="active"
                data-cy="active"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.mealNutrition.cursor')}
                id="meal-nutrition-cursor"
                name="cursor"
                data-cy="cursor"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.mealNutrition.lastupdated')}
                id="meal-nutrition-lastupdated"
                name="lastupdated"
                data-cy="lastupdated"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.mealNutrition.microSec')}
                id="meal-nutrition-microSec"
                name="microSec"
                data-cy="microSec"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.mealNutrition.total')}
                id="meal-nutrition-total"
                name="total"
                data-cy="total"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.mealNutrition.rdi')}
                id="meal-nutrition-rdi"
                name="rdi"
                data-cy="rdi"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.mealNutrition.dailyTotal')}
                id="meal-nutrition-dailyTotal"
                name="dailyTotal"
                data-cy="dailyTotal"
                type="text"
              />
              <ValidatedField
                id="meal-nutrition-meal"
                name="meal"
                data-cy="meal"
                label={translate('tinyMedicRestApp.mealNutrition.meal')}
                type="select"
                required
              >
                <option value="" key="0" />
                {meals
                  ? meals.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <FormText>
                <Translate contentKey="entity.validation.required">This field is required.</Translate>
              </FormText>
              <ValidatedField
                id="meal-nutrition-nutrition"
                name="nutrition"
                data-cy="nutrition"
                label={translate('tinyMedicRestApp.mealNutrition.nutrition')}
                type="select"
                required
              >
                <option value="" key="0" />
                {nutritionIPS
                  ? nutritionIPS.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <FormText>
                <Translate contentKey="entity.validation.required">This field is required.</Translate>
              </FormText>
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/meal-nutrition" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default MealNutritionUpdate;
